import { PredefinedDateValueT } from '@mulesoft/anypoint-components/lib/DatePicker'

export const OFF = 'Off';

export type TimeOptionMap = {
  mule: string,
  graph: string
}

export const   TIME_OPTIONS_MAPPING: TimeOptionMap[] = [
  {mule: 'minutes', graph: 'm'},
  {mule: 'hours', graph: 'h'},
  {mule: 'days', graph: 'd'},
  {mule: 'months', graph: 'M'},
  {mule: 'years', graph: 'y'}
];

export const getTimeOptions = (isTitanium: boolean, resourceType?: string): PredefinedDateTimeOption[] => {
  return resourceType === 'api' || isTitanium ? DEFAULT_TIME_OPTIONS.concat(EXTRA_TIME_OPTIONS) : DEFAULT_TIME_OPTIONS
}

export type PredefinedDateTimeOption = {
  label: string,
  value: PredefinedDateValueT
}

export const DEFAULT_TIME_OPTIONS: PredefinedDateTimeOption[] = [
  {label: '5 minutes', value: {amount: 5, format: 'minutes'}},
  {label: '15 minutes', value: {amount: 15, format: 'minutes'}},
  {label: '30 minutes', value: {amount: 30, format: 'minutes'}},
  {label: '1 hour', value: {amount: 1, format: 'hours'}},
  {label: '3 hours', value: {amount: 3, format: 'hours'}},
  {label: '6 hours', value: {amount: 6, format: 'hours'}},
  {label: '12 hours', value: {amount: 12, format: 'hours'}},
  {label: '24 hours', value: {amount: 24, format: 'hours'}},
  {label: '3 days', value: {amount: 3, format: 'days'}},
  {label: '5 days', value: {amount: 5, format: 'days'}},
  {label: '7 days', value: {amount: 7, format: 'days'}},
  {label: '15 days', value: {amount: 15, format: 'days'}},
  {label: '30 days', value: {amount: 30, format: 'days'}}
];

export const EXTRA_TIME_OPTIONS: PredefinedDateTimeOption[] = [
  {label: '60 days', value: {amount: 60, format: 'days'}},
  {label: '90 days', value: {amount: 90, format: 'days'}}
];

export const  REFRESH_INTERVALS = [
  {label: '5s'},
  {label: '10s'},
  {label: '30s'},
  {label: '1m'},
  {label: '5m'},
  {label: '15m'},
  {label: '30m'},
  {label: '1h'},
  {label: '1d'},
];
